// The event's page on Web, addressed the way Web links it (sportya-web src/state/events/eventRoute.js
// buildEventHref): the ObjectId stays the identity and the name's slug follows it. Web adds the
// visitor's language itself.
const COMBINING_MARKS = /[\u0300-\u036f]/g

export const slugifyEventName = (name = '') => name
  .normalize('NFKD')
  .replace(COMBINING_MARKS, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, '-')
  .replace(/^-|-$/g, '')

export const eventWebPath = (eventId, eventName) => {
  const id = String(eventId).toLowerCase()
  const slug = typeof eventName === 'string' ? slugifyEventName(eventName) : ''
  return '/events/' + (slug ? id + '-' + slug : id)
}
